import ApplicantPersonalInfo from '../../ui/applicantPersonalInfo/applicantPersonalInfo';
import { ComboBox } from '../../ui/comboBox/ComboBox';
import { CreditApplicationType } from 'src/utils/enums/financialTypes.enum';
import { format } from 'date-fns';
import { getApplicantValidations } from './validations';
import { getTitleOptions } from '../utils';
import i18n from 'i18next';
import Input from 'src/components/forms/input';
import { IUser } from 'src/utils/interfaces/user';
import { JointAppContext } from '../ApplicantInfo/context';
import References from '../../ui/referencesSection/references';
import ResidenceForm from '../../ui/residenceForm/residenceForm';
import { useCreditForm } from 'src/customHooks/useCreditForm';
import { useFormik } from 'formik';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import {
    CREDIT_APPLICANT_ADDRESS1_ERROR,
    CREDIT_APPLICANT_ADRESSMONTH_ERROR,
    CREDIT_APPLICANT_ADRESSYEAR_ERROR,
    CREDIT_APPLICANT_BIRTHDATE_ERROR,
    CREDIT_APPLICANT_CITY_ERROR,
    CREDIT_APPLICANT_ZIP_CA_ERROR,
    CREDIT_APPLICANT_ZIP_US_ERROR,
    LABEL_FIELD_ERROR_REQUIRED,
    LABEL_FIELD_ERROR_REQUIRED_VALID,
} from 'src/localization/resouceKeys';
import {
    formatDateOfBirth,
    formatPhone,
    formatPostalCode_CA,
    formatPostalCode_US,
    formatSIN,
    formatSIN_CA,
} from '../../../../utils/formatInputs';
import { isSiteCanadian, safeString } from 'src/utils/helpers';
import { NUMBER_FIVE, NUMBER_ZERO } from 'src/utils/constants';
import React, { useContext, useEffect, useState } from 'react';
import './style.scss';

const telRegex =
    /^((?!\(000\)\s000-0000)(?!\(111\)\s111-1111)(?!\(222\)\s222-2222)(?!\(333\)\s333-3333)(?!\(444\)\s444-4444)(?!\(555\)\s555-5555)(?!\(666\)\s666-6666)(?!\(777\)\s777-7777)(?!\(888\)\s888-8888)(?!\(999\)\s999-9999)(\(\d{3}\)\s\d{3}-\d{4}))?$/i;
const nameRegex = /^([^0-9]){1,20}$/i;
const middleRegex = /^([^0-9]){1}$/i;
export interface IApplicantForm {
    applicationType: string;
    handlerUpdate: any;
    isDisabled?: boolean;
    setApplicantData: Function;
    setCoapplicantData: Function;
    isCoApplicant?: boolean;
    initialPrimaryApplicant?: any;
    initialJointOrCoAppRelationship?: any;
    isEditMode?: boolean;
    isFieldValueUpdated?: boolean;
    setIsFieldValueUpdated: Function;
}

export interface IReference {
    firstName: string;
    middleInitial: string;
    lastName: string;
    referencePhone: string;
    relationship: string;
    errorFirstName?: boolean;
    errorMiddleInitial?: boolean;
    errorLastName?: boolean;
    errorPhone?: boolean;
}
const MINADDRESSYEARS = 2;

const ApplicantForm: React.FC<IApplicantForm> = ({
    applicationType,
    handlerUpdate,
    isDisabled = false,
    setApplicantData,
    setCoapplicantData,
    isCoApplicant = false,
    initialPrimaryApplicant = null,
    initialJointOrCoAppRelationship = null,
    isEditMode = false,
    isFieldValueUpdated = false,
    setIsFieldValueUpdated,
}) => {
    const CERO = 0;
    const { applicantInfo, businessComercial } = useLocalization();
    const { markCreditFormTouched } = useCreditForm();
    const dealerDataInfo = useSelector((state: IUser) => {
        return state.dealerDataInfo;
    });
    const isCanada =
        dealerDataInfo?.dealer.country === 'Canada' ||
        dealerDataInfo?.dealer.country === 'CA';
    const usesBusinessRelationshipOptions =
        applicationType === CreditApplicationType.BUSINESS_COAPP ||
        applicationType === CreditApplicationType.BUSINESS_PG;

    const getDealerCountry = isCanada ? 'CA' : 'US';

    const context = useContext(JointAppContext);
    const [state, setState] = useState<string>('');

    const ResidenceTypeMap = {
        Rent: 'Rent',
        BuyingOrOwning: 'Own',
        ParentsRelativeOrGuardian: 'Parents/Guardian',
    };
    type ResidenceTypeKeys = keyof typeof ResidenceTypeMap;
    const [typeOfResidence, setTypeOfResidence] = useState<string>(
        ResidenceTypeMap[
            initialPrimaryApplicant?.Residence
                ?.ResidenceType as ResidenceTypeKeys
        ] ?? 'Rent',
    );

    const [stateMistake, setStateMistake] = useState<boolean>(true);
    const [previousState, setPreviousState] = useState<string>('');
    const [previousCountry, setPreviousCountry] = useState<string>('US');

    const [previousTypeOfResidence, setPreviousTypeOfResidence] =
        useState<string>(
            ResidenceTypeMap[
                initialPrimaryApplicant?.PreviousResidence
                    ?.ResidenceType as ResidenceTypeKeys
            ] ?? 'Rent',
        );

    const [previousStateMistake, setPreviousStateMistake] =
        useState<boolean>(true);
    const [referencesObject, setReferencesObject] = useState<IReference[]>([]);
    const [relationship, setRelationship] = useState<any>(
        applicantInfo.RELATIONSHIP_NONE,
    );
    const [oldHomephone, setOldHomephone] = useState<string>('');
    const [oldCellphone, setOldCellphone] = useState<string>('');
    const [oldWorkphone, setOldWorkphone] = useState<string>('');
    const [oldBirthday, setOldBirthday] = useState<string>('');

    useEffect(() => {
        setStateMistake(true);
    }, [state]);
    useEffect(() => {
        setPreviousStateMistake(true);
    }, [previousState]);

    const handleChangeReference = (reference: any) => {
        setReferencesObject(reference);
    };

    function getRelationOPtions() {
        return [
            { value: 'NP', label: applicantInfo.RELATIONSHIP_NONE },
            { value: 'AU', label: applicantInfo.RELATIONSHIP_AUNT },
            {
                value: 'BF',
                label: applicantInfo.RELATIONSHIP_BOYFRIEND,
            },
            { value: 'BR', label: applicantInfo.RELATIONSHIP_BROTHER },
            { value: 'FR', label: applicantInfo.RELATIONSHIP_FRIEND },
            {
                value: 'GF',
                label: applicantInfo.RELATIONSHIP_GRANDFATHER,
            },
            {
                value: 'GFR',
                label: applicantInfo.RELATIONSHIP_GIRLFRIEND,
            },
            {
                value: 'GM',
                label: applicantInfo.RELATIONSHIP_GRANDMOTHER,
            },
            { value: 'PT', label: applicantInfo.RELATIONSHIP_PARENT },
            { value: 'SI', label: applicantInfo.RELATIONSHIP_SISTER },
            { value: 'UK', label: applicantInfo.RELATIONSHIP_SPOUSE },
            { value: 'UN', label: applicantInfo.RELATIONSHIP_UNCLE },
            { value: 'O', label: applicantInfo.RELATIONSHIP_OTHER },
        ];
    }

    const [submitErrors, setSubmitErrors] = useState({
        identificationNumber: '',
        dateOfBirth: '',
        addressLine1: '',
        addressLine2: '',
        firstName: '',
        middleInitial: '',
        lastName: '',
        city: '',
        quebecMonthlyHoising: '',
        timeAtAddrYears: '',
        timeAtAddrMonths: '',
        rentOrMortgagePymyt: '',
        quebeckMonthlyMortgage: '',
        telePhoneHome: '',
        cellPhoneNumber: '',
        telePhoneWork: '',
        emailAddress: '',
        previousAccountNumber: '',
        zipOrPostalCode: '',
        previousAddressLine1: '',
        previousAddressLine2: '',
        previousCity: '',
        previousZipOrPostalCode: '',
        previousTimeAtAddrYears: '',
        previousTimeAtAddrMonths: '',
        relationship: '',
    });

    let phoneNote = '';

    const getCountryBasedParams = (isCanada: boolean) => {
        if (isCanada) {
            phoneNote = applicantInfo.PHONE_NOTE_CA;
        } else {
            phoneNote = applicantInfo.PHONE_NOTE_US;
        }
    };

    getCountryBasedParams(isCanada);

    const getCleanErrors = () => {
        return {
            identificationNumber: '',
            dateOfBirth: '',
            addressLine1: '',
            addressLine2: '',
            firstName: '',
            middleInitial: '',
            lastName: '',
            city: '',
            quebecMonthlyHoising: '',
            timeAtAddrYears: '',
            timeAtAddrMonths: '',
            rentOrMortgagePymyt: '',
            quebeckMonthlyMortgage: '',
            telePhoneHome: '',
            cellPhoneNumber: '',
            telePhoneWork: '',
            emailAddress: '',
            previousAccountNumber: '',
            zipOrPostalCode: '',
            previousAddressLine1: '',
            previousAddressLine2: '',
            previousCity: '',
            previousZipOrPostalCode: '',
            previousTimeAtAddrYears: '',
            previousTimeAtAddrMonths: '',
            relationship: '',
        };
    };

    const validatePreviousAddress = () => {
        let isValid = true;
        if (Number(values.timeAtAddrYears) >= MINADDRESSYEARS) {
            return isValid;
        }
        const errorsToSubmit = getCleanErrors();
        if (values.previousAddressLine1 == '') {
            errorsToSubmit.previousAddressLine1 = i18n.t(
                CREDIT_APPLICANT_ADDRESS1_ERROR,
            );
            isValid = false;
        }

        if (values.previousCity == '') {
            errorsToSubmit.previousCity = i18n.t(CREDIT_APPLICANT_CITY_ERROR);
            isValid = false;
        }

        let zipRegex = /^(?!00000)[0-9]{5}$/i;
        let zipError = i18n.t(CREDIT_APPLICANT_ZIP_US_ERROR);
        if (previousCountry == 'CA') {
            zipRegex =
                /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ -]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i;
            zipError = i18n.t(CREDIT_APPLICANT_ZIP_CA_ERROR);
        }

        if (
            values.previousZipOrPostalCode == '' ||
            !values.previousZipOrPostalCode.match(zipRegex)
        ) {
            errorsToSubmit.previousZipOrPostalCode = zipError;
            isValid = false;
        }

        if (values.previousTimeAtAddrYears === '') {
            errorsToSubmit.previousTimeAtAddrYears = i18n.t(
                CREDIT_APPLICANT_ADRESSYEAR_ERROR,
            );
            isValid = false;
        }

        if (values.previousTimeAtAddrMonths == '') {
            errorsToSubmit.previousTimeAtAddrMonths = i18n.t(
                CREDIT_APPLICANT_ADRESSMONTH_ERROR,
            );
            isValid = false;
        }

        if (previousState == '') {
            setPreviousStateMistake(false);
            isValid = false;
        }

        if (!isValid) {
            setSubmitErrors(errorsToSubmit);
        }
        return isValid;
    };

    function validateState() {
        const requiredErr = i18n.t(LABEL_FIELD_ERROR_REQUIRED);
        const requiredValidErr = i18n.t(LABEL_FIELD_ERROR_REQUIRED_VALID);
        let isStateValid = true;
        let stateErrorsToSubmit = getCleanErrors();
        if (state == '') {
            setStateMistake(false);
            isStateValid = false;
        }

        if (
            state == 'QC' &&
            (values.quebecMonthlyHoising === '' ||
                Number(values.quebecMonthlyHoising) < Number('0'))
        ) {
            stateErrorsToSubmit = {
                ...stateErrorsToSubmit,
                quebecMonthlyHoising:
                    values.quebecMonthlyHoising === ''
                        ? requiredErr
                        : requiredValidErr,
            };
            isStateValid = false;
        }

        if (
            state === 'QC' &&
            (values.quebeckMonthlyMortgage === '' ||
                Number(values.quebeckMonthlyMortgage) < Number('0'))
        ) {
            stateErrorsToSubmit = {
                ...stateErrorsToSubmit,
                quebeckMonthlyMortgage:
                    values.quebeckMonthlyMortgage === ''
                        ? requiredErr
                        : requiredValidErr,
            };
            isStateValid = false;
        }

        if (
            state != 'QC' &&
            (values.rentOrMortgagePymyt === '' ||
                Number(values.rentOrMortgagePymyt) < Number('0'))
        ) {
            stateErrorsToSubmit = {
                ...stateErrorsToSubmit,
                rentOrMortgagePymyt:
                    values.rentOrMortgagePymyt === ''
                        ? requiredErr
                        : requiredValidErr,
            };
            isStateValid = false;
        }

        return {
            isStateValid,
            stateErrorsToSubmit,
        };
    }

    function setEmptyPhones() {
        let emptyPhones = 0;
        let emptyTelephoneError = '';
        let emptyCellphoneError = '';
        let emptyWorkphoneError = '';
        const requiredErr = i18n.t(LABEL_FIELD_ERROR_REQUIRED);

        if (values.telePhoneHome == '') {
            emptyPhones++;
            emptyTelephoneError = requiredErr;
        }
        if (values.telePhoneWork == '') {
            emptyPhones++;
            emptyWorkphoneError = requiredErr;
        }
        if (values.cellPhoneNumber == '') {
            emptyPhones++;
            emptyCellphoneError = requiredErr;
        }

        return {
            emptyPhones,
            emptyTelephoneError,
            emptyCellphoneError,
            emptyWorkphoneError,
        };
    }

    const allValidationsPass = () => {
        const { isStateValid, stateErrorsToSubmit } = validateState();
        let isFormValid = isStateValid;
        let errorsToSubmit = {
            ...stateErrorsToSubmit,
        };

        const requiredErr = i18n.t(LABEL_FIELD_ERROR_REQUIRED);
        const birthdateErr = i18n.t(CREDIT_APPLICANT_BIRTHDATE_ERROR);
        const APPLICANT_AGE_MIN = 18;
        const APPLICANT_AGE_CANADA_SPECIAL_MIN = 19;
        const APPLICANT_AGE_MAX = 125;
        const MAXEPTYONE = 1;
        let minyears = APPLICANT_AGE_MIN;
        const specialStates = ['BC', 'NB', 'NL', 'NS', 'NT', 'NU', 'YT'];
        if (specialStates.includes(state)) {
            minyears = APPLICANT_AGE_CANADA_SPECIAL_MIN;
        }

        const maxEmpty = MAXEPTYONE;
        const {
            emptyCellphoneError,
            emptyPhones,
            emptyTelephoneError,
            emptyWorkphoneError,
        } = setEmptyPhones();

        if (
            isCoApplicant &&
            (relationship === getRelationOPtions()[0].value ||
                relationship === applicantInfo.RELATIONSHIP_NONE)
        ) {
            errorsToSubmit = {
                ...errorsToSubmit,
                relationship: requiredErr,
            };
            isFormValid = false;
        }

        if (emptyPhones > maxEmpty) {
            errorsToSubmit = {
                ...errorsToSubmit,
                telePhoneHome: emptyTelephoneError,
                telePhoneWork: emptyWorkphoneError,
                cellPhoneNumber: emptyCellphoneError,
            };
            isFormValid = false;
        }
        if (
            typeof values.dateOfBirth !== 'string' ||
            values.dateOfBirth.length !== Number('10')
        ) {
            errorsToSubmit = {
                ...errorsToSubmit,
                dateOfBirth: birthdateErr,
            };
            isFormValid = false;
        }

        const regex = /^\d{2}\/\d{2}\/\d{4}$/;
        if (!regex.test(values.dateOfBirth)) {
            errorsToSubmit = {
                ...errorsToSubmit,
                dateOfBirth: birthdateErr,
            };
            isFormValid = false;
        }

        const maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() - minyears);
        const minDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - APPLICANT_AGE_MAX);
        const currentBirthDay = new Date(values.dateOfBirth);
        if (!(currentBirthDay > minDate && currentBirthDay < maxDate)) {
            errorsToSubmit = {
                ...errorsToSubmit,
                dateOfBirth: birthdateErr,
            };
            isFormValid = false;
        }

        let flagValidation = CERO;

        if (referencesObject.length > CERO) {
            referencesObject.forEach((element) => {
                const newElement = {
                    firstName: element.firstName,
                    lastName: element.lastName,
                    referencePhone: element.referencePhone,
                    relationship: element.relationship,
                    middleInitial: element.middleInitial,
                    errorFirstName: element.errorFirstName,
                    errorLastName: element.errorLastName,
                    errorPhone: element.errorPhone,
                    errorMiddleInitial: element.errorMiddleInitial,
                };
                if (
                    element.firstName.length &&
                    nameRegex.test(element.firstName)
                ) {
                    element.errorFirstName = false;
                } else {
                    element.errorFirstName = true;
                    flagValidation++;
                }
                if (
                    element.middleInitial === '' ||
                    middleRegex.test(element.middleInitial)
                ) {
                    element.errorMiddleInitial = false;
                } else {
                    element.errorMiddleInitial = true;
                    flagValidation++;
                }
                if (
                    element.lastName.length &&
                    nameRegex.test(element.lastName)
                ) {
                    element.errorLastName = false;
                } else {
                    element.errorLastName = true;
                    flagValidation++;
                }
                if (
                    element.referencePhone.length &&
                    telRegex.test(element.referencePhone)
                ) {
                    element.errorPhone = false;
                } else {
                    element.errorPhone = true;
                    flagValidation++;
                }
                return newElement;
            });
            setReferencesObject([...referencesObject]);
            if (flagValidation > CERO) {
                isFormValid = false;
            } else isFormValid = true;
        }

        if (!isFormValid) {
            setSubmitErrors(errorsToSubmit);
            return isFormValid;
        }

        return validatePreviousAddress();
    };

    const buildAndSetApplicantData = () => {
        let previous;
        const MIN_ADDRESSYEARS = 2;
        if (+values.timeAtAddrYears < MIN_ADDRESSYEARS) {
            let previousAddressLine2;

            if (values.previousAddressLine2) {
                previousAddressLine2 = values.previousAddressLine2.trim();
            }

            previous = {
                timeAtAddress: {
                    timeAtAddrYears: values.previousTimeAtAddrYears,
                    timeAtAddrMonths: values.previousTimeAtAddrMonths,
                },
                address: {
                    addressLine1: values.previousAddressLine1.trim(),
                    addressLine2: previousAddressLine2,
                    city: values.previousCity,
                    zipOrPostalCode:
                        values.previousZipOrPostalCode.toUpperCase(),
                    country: previousCountry,
                    state: previousState,
                },
                typeOfResidence: previousTypeOfResidence,
            };
        }

        let quebecMonthlyHoising,
            rentOrMortgagePymyt,
            quebeckMonthlyMortgage,
            applicantRelationship;

        if (state == 'QC') {
            quebecMonthlyHoising = +values.quebecMonthlyHoising;
            quebeckMonthlyMortgage = +values.quebeckMonthlyMortgage;
        } else {
            rentOrMortgagePymyt = +values.rentOrMortgagePymyt;
        }

        if (isCoApplicant && relationship) {
            applicantRelationship = relationship;
        }

        let references;
        const EMPTY = 0;
        if (referencesObject.length > EMPTY) {
            references = referencesObject.map((element) => {
                let middleInitial;

                if (element.middleInitial) {
                    middleInitial = element.middleInitial;
                }

                const newElement = {
                    firstName: element.firstName,
                    lastName: element.lastName,
                    contact: {
                        phoneNumber: element.referencePhone
                            .replaceAll('(', '')
                            .replaceAll(')', '')
                            .replaceAll(' ', '')
                            .replaceAll('-', ''),
                    },
                    relationship: element.relationship,
                    middleInitial,
                };
                return newElement;
            });
        }

        const checkVariable = (value: any) => {
            if (value) {
                return value;
            }
            return undefined;
        };

        const previousAccountNumber = checkVariable(
            values.previousAccountNumber,
        );
        const middleInitial = checkVariable(values.middleInitial);
        const telePhoneHome = checkVariable(values.telePhoneHome);
        const cellPhoneNumber = checkVariable(values.cellPhoneNumber);
        const telePhoneWork = checkVariable(values.telePhoneWork);
        const addressLine2 = checkVariable(values.addressLine2.trim());
        const identificationNumber = values.identificationNumber.replaceAll(
            '-',
            '',
        );

        const applicationInfoData = {
            applicantName: {
                firstName: values.firstName,
                middleInitial,
                lastName: values.lastName,
            },
            residence: {
                current: {
                    timeAtAddress: {
                        timeAtAddrYears: values.timeAtAddrYears,
                        timeAtAddrMonths: values.timeAtAddrMonths,
                    },
                    address: {
                        addressLine1: values.addressLine1.trim(),
                        addressLine2,
                        city: values.city,
                        state: state,
                        country: getDealerCountry,
                        zipOrPostalCode: values.zipOrPostalCode.toUpperCase(),
                    },
                    typeOfResidence: typeOfResidence,
                },
                previous,
            },
            applicantRelationship,
            ...(identificationNumber ? { identificationNumber } : {}),
            dateOfBirth: values.dateOfBirth,
            telePhoneHome,
            cellPhoneNumber,
            telePhoneWork,
            emailAddress: values.emailAddress.trim().toLowerCase(),
            previousAccountNumber,
            references,
            rentOrMortgagePymyt,
            quebecMonthlyHoising,
            quebeckMonthlyMortgage,
        };

        if (isCoApplicant) {
            setCoapplicantData(applicationInfoData);
        } else {
            setApplicantData(applicationInfoData);
        }
    };

    const handleCustomSubmit = () => {
        setSubmitErrors(getCleanErrors());
        if (!allValidationsPass()) {
            if (isCoApplicant) {
                setCoapplicantData({});
            } else {
                setApplicantData({});
            }
            return;
        }
        buildAndSetApplicantData();
    };

    const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        handleBlur,
        setFieldValue,
        setFieldTouched,
    } = useFormik({
        initialValues: {
            identificationNumber: '',
            dateOfBirth: '',
            addressLine1: '',
            addressLine2: '',
            firstName: '',
            middleInitial: '',
            lastName: '',
            city: '',
            quebecMonthlyHoising: '',
            timeAtAddrYears: '',
            timeAtAddrMonths: '',
            rentOrMortgagePymyt: '',
            quebeckMonthlyMortgage: '',
            telePhoneHome: '',
            cellPhoneNumber: '',
            telePhoneWork: '',
            emailAddress: '',
            previousAccountNumber: '',
            zipOrPostalCode: '',
            previousAddressLine1: '',
            previousAddressLine2: '',
            previousCity: '',
            previousZipOrPostalCode: '',
            previousTimeAtAddrYears: '',
            previousTimeAtAddrMonths: '',
            relationship: '',
        },
        validationSchema: getApplicantValidations(),
        onSubmit: handleCustomSubmit,
        validateOnChange: false,
        validateOnBlur: false,
    });

    const handleCustomChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    ) => {
        const { name } = e.target;
        let { value } = e.target;
        const isCanadian = isSiteCanadian();
        switch (name) {
            case 'identificationNumber':
                if (value > values[name])
                    value = isCanadian ? formatSIN_CA(value) : formatSIN(value);
                break;
            case 'zipOrPostalCode':
                if (value > values[name])
                    value = isCanadian
                        ? formatPostalCode_CA(value)
                        : formatPostalCode_US(value);
                break;
        }
        e.target.name = name;
        e.target.value = value;
        handleChange(e);
    };

    useEffect(() => {
        if (handlerUpdate) {
            handlerUpdate({ validate: handleSubmit });
        }
    }, []);

    useEffect(() => {
        const handleLanguageChange = () => {
            const hasErr = Object.values(submitErrors).some(
                (value) => value !== '',
            );
            if (hasErr) {
                setSubmitErrors(getCleanErrors());
                allValidationsPass();
            }
            Object.keys(errors).forEach((field) => {
                setFieldTouched(field, true, true);
            });
        };

        i18n.on('languageChanged', handleLanguageChange);
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n, errors, submitErrors, setFieldTouched]);

    useEffect(() => {
        if (!isCoApplicant) {
            if (values.addressLine1)
                context.coApp.addressLine1 = values.addressLine1.trim();
            if (values.addressLine2)
                context.coApp.addressLine2 = values.addressLine2.trim();
            if (values.telePhoneHome)
                context.coApp.telePhoneHome = values.telePhoneHome;
            if (values.city) context.coApp.city = values.city;
            if (values.zipOrPostalCode)
                context.coApp.zip = values.zipOrPostalCode.toUpperCase();
            if (state) context.coApp.state = state;
        }
    }, [
        values.addressLine1,
        values.addressLine2,
        values.telePhoneHome,
        state,
        values.zipOrPostalCode,
    ]);

    useEffect(() => {
        if (values.telePhoneHome) {
            if (values.telePhoneHome.length > oldHomephone.length) {
                values.telePhoneHome = formatPhone(values.telePhoneHome);
            }
            setOldHomephone(values.telePhoneHome);
        }
        if (values.telePhoneWork) {
            if (values.telePhoneWork.length > oldWorkphone.length) {
                values.telePhoneWork = formatPhone(values.telePhoneWork);
            }
            setOldWorkphone(values.telePhoneWork);
        }
        if (values.cellPhoneNumber) {
            if (values.cellPhoneNumber.length > oldCellphone.length) {
                values.cellPhoneNumber = formatPhone(values.cellPhoneNumber);
            }
            setOldCellphone(values.cellPhoneNumber);
        }
    }, [values.telePhoneHome, values.telePhoneWork, values.cellPhoneNumber]);

    useEffect(() => {
        if (values.dateOfBirth) {
            if (values.dateOfBirth.length > oldBirthday.length) {
                values.dateOfBirth = formatDateOfBirth(values.dateOfBirth);
            }
            setOldBirthday(values.dateOfBirth);
        }
    }, [values.dateOfBirth]);

    useEffect(() => {
        values.zipOrPostalCode = values.zipOrPostalCode.toUpperCase();
    }, [values.zipOrPostalCode]);

    //for edit mode
    useEffect(() => {
        if (initialPrimaryApplicant) {
            let formattedDate = null;
            if (initialPrimaryApplicant?.DateOfBirth) {
                try {
                    const parseDate = new Date(
                        initialPrimaryApplicant?.DateOfBirth,
                    );

                    if (parseDate) {
                        formattedDate = format(parseDate, 'MM/dd/yyy');
                    }
                } catch (error) {}
            }

            let zipCode = null;
            const code =
                initialPrimaryApplicant?.Residence?.Address?.ZipCode?.Code ??
                '';
            const codeExtension =
                initialPrimaryApplicant?.Residence?.Address?.ZipCode
                    ?.CodeExtension ?? '';

            if (isCanada) {
                zipCode = code === '' ? code : code + '-' + codeExtension;
            } else {
                const zip = `${code}${codeExtension}`;
                zipCode = zip.slice(NUMBER_ZERO, NUMBER_FIVE);
            }

            setFieldValue(
                'firstName',
                initialPrimaryApplicant?.ApplicantName?.FirstName ?? '',
            );
            setFieldValue(
                'middleInitial',
                initialPrimaryApplicant?.ApplicantName?.MiddleInitial ?? '',
            );
            setFieldValue(
                'lastName',
                initialPrimaryApplicant?.ApplicantName?.LastName ?? '',
            );
            const initialIdentificationNumber = safeString(
                initialPrimaryApplicant?.IdentificationNumber?.Number,
            );
            setFieldValue('identificationNumber', initialIdentificationNumber);
            setFieldValue('dateOfBirth', formattedDate ?? '');
            setFieldValue(
                'addressLine1',
                safeString(
                    initialPrimaryApplicant?.Residence?.Address?.AddressLine1,
                ).trim(),
            );
            setFieldValue(
                'addressLine2',
                safeString(
                    initialPrimaryApplicant?.Residence?.Address?.AddressLine2,
                ).trim(),
            );
            setFieldValue(
                'city',
                safeString(
                    initialPrimaryApplicant?.Residence?.Address?.City,
                ).trim(),
            );
            setFieldValue('zipOrPostalCode', zipCode ?? '');

            setFieldValue(
                'timeAtAddrYears',
                initialPrimaryApplicant?.Residence?.YearsAtAddress ?? '',
            );
            setFieldValue(
                'timeAtAddrMonths',
                initialPrimaryApplicant?.Residence?.MonthsAtAddress ?? '',
            );
            setFieldValue(
                'rentOrMortgagePymyt',
                initialPrimaryApplicant?.Expenses?.MonthlyLivingExpenses ?? '',
            );
            setFieldValue(
                'quebeckMonthlyMortgage',
                initialPrimaryApplicant?.Expenses?.MonthlyLivingExpenses ?? '',
            );
            setFieldValue(
                'quebecMonthlyHoising',
                initialPrimaryApplicant?.Expenses
                    ?.MonthlyDisbursementsCreditLease ?? '',
            );

            setFieldValue(
                'telePhoneHome',
                initialPrimaryApplicant?.HomePhoneNumber?.PhoneNumber ?? '',
            );
            setFieldValue(
                'cellPhoneNumber',
                initialPrimaryApplicant?.CellPhoneNumber?.PhoneNumber ?? '',
            );
            setFieldValue(
                'telePhoneWork',
                initialPrimaryApplicant?.WorkPhoneNumber?.PhoneNumber ?? '',
            );
            setFieldValue(
                'emailAddress',
                safeString(initialPrimaryApplicant?.EmailAddress?.Address)
                    .trim()
                    .toLowerCase(),
            );
            setFieldValue(
                'previousAccountNumber',
                initialPrimaryApplicant?.PreviousAccountNumber?.Number ?? '',
            );

            //previousAddress
            setFieldValue(
                'previousAddressLine1',
                safeString(
                    initialPrimaryApplicant?.PreviousResidence?.Address
                        ?.AddressLine1,
                ).trim(),
            );
            setFieldValue(
                'previousAddressLine2',
                safeString(
                    initialPrimaryApplicant?.PreviousResidence?.Address
                        ?.AddressLine2,
                ).trim(),
            );
            setFieldValue(
                'previousCity',
                safeString(
                    initialPrimaryApplicant?.PreviousResidence?.Address?.City,
                ).trim(),
            );

            let prevZipCode = null;

            const prevCountry =
                initialPrimaryApplicant?.PreviousResidence?.Address?.Country ??
                null;

            if (
                prevCountry === 'Canada' &&
                initialPrimaryApplicant?.PreviousResidence?.Address?.ZipCode
                    ?.Code &&
                initialPrimaryApplicant?.PreviousResidence?.Address?.ZipCode
                    ?.CodeExtension
            ) {
                prevZipCode =
                    initialPrimaryApplicant?.PreviousResidence?.Address?.ZipCode
                        ?.Code +
                    '-' +
                    initialPrimaryApplicant?.PreviousResidence?.Address?.ZipCode
                        ?.CodeExtension;
            }

            if (
                prevCountry === 'USA' &&
                initialPrimaryApplicant?.PreviousResidence?.Address?.ZipCode
                    ?.Code &&
                typeof initialPrimaryApplicant?.PreviousResidence?.Address
                    ?.ZipCode?.Code === 'number'
            ) {
                prevZipCode =
                    initialPrimaryApplicant?.PreviousResidence?.Address?.ZipCode?.Code.toString().slice(
                        NUMBER_ZERO,
                        NUMBER_FIVE,
                    );
            }

            setFieldValue('previousZipOrPostalCode', prevZipCode ?? '');

            setFieldValue(
                'previousTimeAtAddrYears',
                initialPrimaryApplicant?.PreviousResidence?.YearsAtAddress ??
                    '',
            );
            setFieldValue(
                'previousTimeAtAddrMonths',
                initialPrimaryApplicant?.PreviousResidence?.MonthsAtAddress ??
                    '',
            );
            setIsFieldValueUpdated(true);
        }
    }, []);

    //for edit mode
    const relationshipKeyMap = {
        None: 'RELATIONSHIP_NONE',
        Aunt: 'RELATIONSHIP_AUNT',
        Boyfriend: 'RELATIONSHIP_BOYFRIEND',
        Brother: 'RELATIONSHIP_BROTHER',
        Friend: 'RELATIONSHIP_FRIEND',
        Girlfriend: 'RELATIONSHIP_GIRLFRIEND',
        Grandfather: 'RELATIONSHIP_GRANDFATHER',
        Grandmother: 'RELATIONSHIP_GRANDMOTHER',
        Parent: 'RELATIONSHIP_PARENT',
        Sister: 'RELATIONSHIP_SISTER',
        Spouse: 'RELATIONSHIP_SPOUSE',
        Uncle: 'RELATIONSHIP_UNCLE',
        Other: 'RELATIONSHIP_OTHER',
    };

    //for edit mode
    type RelationshipKeys = keyof typeof relationshipKeyMap;
    type ApplicantInfoKeys = keyof typeof applicantInfo;

    //for edit mode
    const getRelationshipkeyValue = () => {
        return relationshipKeyMap[
            initialJointOrCoAppRelationship as RelationshipKeys
        ] as ApplicantInfoKeys;
    };

    const getDefaultRelationship = () => {
        if (initialJointOrCoAppRelationship) {
            return applicantInfo[getRelationshipkeyValue()];
        }

        return applicantInfo.RELATIONSHIP_NONE;
    };

    useEffect(() => {
        if (initialJointOrCoAppRelationship) {
            const relationShipOption = getRelationOPtions().find((ele) => {
                return ele.label === getDefaultRelationship();
            })?.value;

            setRelationship(relationShipOption);
        }
    }, []);

    //for edit bussinesCoapp
    const businessRelationshipKeyMap = {
        // None: 'None',
        Owner: 'DRIVER_OPTION_OWNER',
        President: 'DRIVER_OPTION_PRESIDENT',
        VicePresident: 'DRIVER_OPTION_VICEPRESIDENT',
        Treasurer: 'DRIVER_OPTION_TREASURER',
        Other: 'DRIVER_OPTION_OTHER',
    };

    type BusinessRelationshipKeys = keyof typeof businessRelationshipKeyMap;
    type BusinessInfoKeys = keyof typeof businessComercial;

    const getBusinessRelationshipkeyValue = () => {
        return businessRelationshipKeyMap[
            initialJointOrCoAppRelationship as BusinessRelationshipKeys
        ] as BusinessInfoKeys;
    };

    const getDefaultBusinessRelationship = () => {
        if (initialJointOrCoAppRelationship) {
            return businessComercial[getBusinessRelationshipkeyValue()];
        }

        return applicantInfo.RELATIONSHIP_NONE;
    };

    useEffect(() => {
        if (
            initialJointOrCoAppRelationship &&
            usesBusinessRelationshipOptions
        ) {
            const relationshipOption = getTitleOptions(businessComercial).find(
                (ele) => {
                    return ele.label === getDefaultBusinessRelationship();
                },
            )?.value;

            setRelationship(relationshipOption);
        }
    }, []);

    const handleKeyDownPhone = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const allowedKeys = [
            'Backspace',
            'Delete',
            'ArrowLeft',
            'ArrowRight',
            'Tab',
            'Home',
            'End',
        ];

        const allowedChars = [
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '(',
            ')',
            '-',
            ' ',
        ];

        if (!allowedKeys.includes(e.key) && !allowedChars.includes(e.key)) {
            e.preventDefault();
        }
    };

    const handleInputChange = (e: any) => {
        handleChange(e);
        markCreditFormTouched();
    };

    const handleAccountNumChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // eslint-disable-next-line no-magic-numbers
        const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
        e.target.value = numericValue;
        handleInputChange(e);
    };

    useEffect(() => {
        if (isEditMode && isFieldValueUpdated) {
            buildAndSetApplicantData();
        }
    }, [isEditMode, isFieldValueUpdated]);

    const Template = (): JSX.Element => {
        return (
            <>
                {isCoApplicant ? (
                    <div className='o-fieldset__row mb-0'>
                        <div className='o-layout align-center'>
                            <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                <div className='c-form-field'>
                                    <label
                                        htmlFor='m1l7e063'
                                        className='c-form-field__label'
                                    >
                                        {applicantInfo.RELATIONSHIP_TITLE}
                                        {isCoApplicant ? '*' : null}
                                    </label>
                                    <div className='c-form-field__box'>
                                        <div className='c-input'>
                                            <ComboBox
                                                name={'relationshipSelector'}
                                                options={
                                                    usesBusinessRelationshipOptions
                                                        ? getTitleOptions(
                                                              businessComercial,
                                                          )
                                                        : getRelationOPtions()
                                                }
                                                defaultValue={
                                                    // getDefaultRelationship()
                                                    applicantInfo.RELATIONSHIP_NONE
                                                }
                                                placeholder={
                                                    usesBusinessRelationshipOptions
                                                        ? getTitleOptions(
                                                              businessComercial,
                                                          ).find((ele) => {
                                                              return (
                                                                  ele.value ===
                                                                  relationship
                                                              );
                                                          })?.label
                                                        : getRelationOPtions().find(
                                                              (ele) => {
                                                                  return (
                                                                      ele.value ===
                                                                      relationship
                                                                  );
                                                              },
                                                          )?.label
                                                }
                                                onSelect={(val: any) => {
                                                    setRelationship(val);
                                                    markCreditFormTouched();
                                                }}
                                                selectedOption={
                                                    values.relationship
                                                }
                                                disabled={isDisabled}
                                                isError={
                                                    isCoApplicant &&
                                                    submitErrors.relationship
                                                        ?.length > Number('0')
                                                        ? true
                                                        : false
                                                }
                                            />
                                        </div>
                                        {isCoApplicant ? (
                                            <div
                                                className='custom-input-error'
                                                hidden={
                                                    !(
                                                        submitErrors
                                                            .relationship
                                                            ?.length >
                                                        Number('0')
                                                    )
                                                }
                                            >
                                                {i18n.t(
                                                    LABEL_FIELD_ERROR_REQUIRED,
                                                )}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                <ApplicantPersonalInfo
                    values={values}
                    errors={errors}
                    touched={touched}
                    handleChange={handleCustomChange}
                    handleBlur={handleBlur}
                    submitErrors={submitErrors}
                />
                <ResidenceForm
                    values={values}
                    errors={errors}
                    touched={touched}
                    handleChange={handleCustomChange}
                    handleBlur={handleBlur}
                    state={state}
                    setState={setState}
                    typeOfResidence={typeOfResidence}
                    setTypeOfResidence={setTypeOfResidence}
                    submitErrors={submitErrors}
                    setSubmitErrors={setSubmitErrors}
                    stateMistake={stateMistake}
                    previousCountry={previousCountry}
                    setPreviousCountry={setPreviousCountry}
                    previousState={previousState}
                    setPreviousState={setPreviousState}
                    previousTypeOfResidence={previousTypeOfResidence}
                    setPreviousTypeOfResidence={setPreviousTypeOfResidence}
                    previousStateMistake={previousStateMistake}
                    isDisabled={isDisabled}
                    isCoaplicant={isCoApplicant}
                    initialState={
                        initialPrimaryApplicant?.Residence?.Address?.State ??
                        null
                    }
                    initialPrevState={
                        initialPrimaryApplicant?.PreviousResidence?.Address
                            ?.State ?? null
                    }
                    initialPrevCountry={
                        initialPrimaryApplicant?.PreviousResidence?.Address
                            ?.Country ?? null
                    }
                    initialYearsAtAddress={
                        initialPrimaryApplicant?.Residence?.YearsAtAddress ??
                        null
                    }
                />
                <div className='phone-note'>{phoneNote}</div>
                <div className='o-fieldset__row'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/3  u-1/1@xs'>
                            <div className='c-form-field'>
                                <div className='c-form-field__box'>
                                    <div className='c-input'>
                                        <Input
                                            labelName={
                                                applicantInfo.HOMEPHONE_LABEL
                                            }
                                            type={'text'}
                                            name={'telePhoneHome'}
                                            handlerChange={handleInputChange}
                                            handlerBlur={handleBlur}
                                            value={values.telePhoneHome}
                                            asErrors={errors.telePhoneHome}
                                            asTouched={touched.telePhoneHome}
                                            asSubmitError={
                                                submitErrors.telePhoneHome
                                            }
                                            maxlength={14}
                                            handleKeyPress={handleKeyDownPhone}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='o-layout__item  u-1/3  u-1/1@xs'>
                            <div className='c-form-field'>
                                <div className='c-form-field__box'>
                                    <div className='c-input'>
                                        <Input
                                            labelName={
                                                applicantInfo.CELLPHONE_LABEL
                                            }
                                            type={'text'}
                                            name={'cellPhoneNumber'}
                                            handlerChange={handleInputChange}
                                            handlerBlur={handleBlur}
                                            value={values.cellPhoneNumber}
                                            asErrors={errors.cellPhoneNumber}
                                            asTouched={touched.cellPhoneNumber}
                                            asSubmitError={
                                                submitErrors.cellPhoneNumber
                                            }
                                            maxlength={14}
                                            handleKeyPress={handleKeyDownPhone}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='o-layout__item  u-1/3  u-1/1@xs'>
                            <div className='c-form-field'>
                                <div className='c-form-field__box'>
                                    <div className='c-input'>
                                        <Input
                                            labelName={
                                                applicantInfo.WORKPHONE_LABEL
                                            }
                                            type={'text'}
                                            name={'telePhoneWork'}
                                            handlerChange={handleInputChange}
                                            handlerBlur={handleBlur}
                                            value={values.telePhoneWork}
                                            asErrors={errors.telePhoneWork}
                                            asTouched={touched.telePhoneWork}
                                            asSubmitError={
                                                submitErrors.telePhoneWork
                                            }
                                            maxlength={14}
                                            handleKeyPress={handleKeyDownPhone}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='o-fieldset__row'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/2  u-1/1@xs'>
                            <div className='c-form-field'>
                                <div className='c-form-field__box'>
                                    <div className='c-input'>
                                        <Input
                                            labelName={
                                                applicantInfo.EMAIL_LABEL
                                            }
                                            type={'text'}
                                            name={'emailAddress'}
                                            handlerChange={handleInputChange}
                                            handlerBlur={handleBlur}
                                            value={values.emailAddress}
                                            asErrors={errors.emailAddress}
                                            asTouched={touched.emailAddress}
                                            asSubmitError={
                                                submitErrors.emailAddress
                                            }
                                            maxlength={50}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(applicationType == CreditApplicationType.INDIVIDUAL ||
                            applicationType == CreditApplicationType.JOINT ||
                            applicationType == CreditApplicationType.COAPP) && (
                            <div className='o-layout__item  u-1/2  u-1/1@xs'>
                                <div className='c-form-field'>
                                    <div className='c-form-field__box'>
                                        <div className='c-input'>
                                            <Input
                                                labelName={
                                                    applicantInfo.PREVACC_LABEL
                                                }
                                                type={'text'}
                                                name={'previousAccountNumber'}
                                                handlerChange={
                                                    handleAccountNumChange
                                                }
                                                handlerBlur={handleBlur}
                                                value={
                                                    values.previousAccountNumber
                                                }
                                                maxlength={10}
                                                asErrors={
                                                    errors.previousAccountNumber
                                                }
                                                asTouched={
                                                    touched.previousAccountNumber
                                                }
                                                asSubmitError={
                                                    submitErrors.previousAccountNumber
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <References
                    handleChangeItemReferences={handleChangeReference}
                    initialReferences={
                        initialPrimaryApplicant?.References?.value ?? null
                    }
                />
            </>
        );
    };

    return <>{Template()}</>;
};

export default ApplicantForm;
